import React, { useState, useEffect } from 'react';
import { Row, Col, Accordion } from 'react-bootstrap';
import { PHASES } from './PersonaData';
import PersonaPhase from './PersonaPhase';

const PersonaState = ({ personaState }) => {
    const [personaStateData, setPersonaStateData] = useState(null);

    useEffect(() => {
        if (personaState !== undefined)
            setPersonaStateData(personaState);
    }, [personaState]);

    if (personaStateData === null) {
        return null;
    }

    console.log(personaStateData.phases);

//     <Accordion.Item eventKey={index} className={"pb-1 accordion-body"}>
//     <Accordion.Header>
//       <h3>
//         General
//       </h3>
//     </Accordion.Header>
//     <Accordion.Body >
//       <ul className="kinks-ul-single py-1 ">
//         <li><strong>Race: </strong> {playerData.race}</li>
//         <li><strong>Weight: </strong> {playerData.weight}</li>
//         <li><strong>Height: </strong> {playerData.height}</li>
//         <li><strong>Age: </strong> {playerData.age}</li>
//         <li><strong>Scent: </strong> {playerData.scent}</li>
//         <li><strong>Gender: </strong> {playerData.gender}</li>
//         <li><strong>Sexual Preference: </strong> {playerData.orientation}</li>
//         <li><strong>Dominant/Submissive: </strong> {playerData.domsubrole}</li>
//         <li><strong>Kinkiness: </strong> {playerData.kinks}</li>
//       </ul>
//     </Accordion.Body>
//   </Accordion.Item>
  

    return (
        <Accordion.Item eventKey={personaStateData.state} className={"pb-1 accordion-body"}>
     <Accordion.Header>
         <h5>State <strong>{personaStateData.state}</strong></h5>
     </Accordion.Header>
     <Accordion.Body >
            <Row className={"pt-5"}>
            </Row>
            <Row>
                <Col md={1}>
                    <strong>Next: </strong>
                </Col>
                <Col md={1}>
                    {personaStateData.nextState}
                </Col>
            </Row>
            <Row>
                {PHASES.map((phase, phaseIndex) =>
                    <PersonaPhase key={phaseIndex} phaseData={personaStateData.phases[phase]} />
                )}
            </Row>
            </Accordion.Body >
       </Accordion.Item>
    );
}

export default PersonaState;